import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 1024 1024",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#dff0fe",
			stroke: "#4788c7",
			strokeLinejoin: "round",
			strokeWidth: 30,
			d: "M231.392 297.578c62.988-50.202 302.511-28.81 414.4-11.84 6.925-24.705 14.328-38.685 36.111-63.936-46.273-13.75-99.605-16.02-243.904-10.064-68.671-10.656-68.671-139.712 0-151.552 317.312 0 538.72 148 558.256 237.392s9.59 62.873 0 100.048c-23.006 57.307-85.84 104.192-104.784 110.704s-101.824 0-101.824 0c-32.092 143.875-71.574 205.418-177.008 279.424-59.447 23.136-97.68 20.128-107.744-53.872l21.904-37.888 31.968-14.8c15.87-28.604 14.722-43.365 0-68.08-22.999-5.874-34.752-5.74-53.872 0-34.784 68.765-62.87 93.492-129.647 110.704v24.272l92.943 50.912 75.776 75.776c2.368 76.723-60.976 91.168-92.944 88.8C361.22 876.89 301.6 838.44 168.64 799.002c-26.486-5.732-30.057-15.395-23.088-40.256 58.775-115.1 40.65-183.322 23.088-213.712-29.558 30.414-99.602 83.694-140.896 0-46.2-93.636 61.568-113.862 117.808-110.704 2.368-24.666 22.85-86.55 85.84-136.752z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#4788c7",
			strokeLinecap: "round",
			strokeWidth: 84,
			d: "M59.736 258.506h81.696m-7.104-120.768h131.424"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 875.512,
			cy: 305.866,
			r: 45.584,
			fill: "#4788c7"
		})
	]
});
export default SvgLogo;
